<template>
  <div>
    <a-modal id='handitem_nz'  v-model="visible"  :width="islang == 'eng' ? '960px' : '1008px' " on-ok="handleOk" @cancel="handleCancel(0)" :footer="null" 
      :keyboard='false' :maskClosable='false' :dialog-style="{ top: onlinestate == 'pc' ? '26%' : onlinestate == 'ipad' ? '22vh' : '11vh', maxWidth:onlinestate=='pc' ? '95vw' :'80%' }" :class="onlinestate=='phone'?'appclass':''">
      <div class='mark-file'>
        <div style="text-align: left;color: #0C8B97;font-weight: 600;padding-top: 10px;"  class="my_fonts">
          <div v-if="onlinestate=='pc'" :style="islang=='eng'?'font-size: 21px;':'font-size: 21px;'">
            {{islang=='eng'?'Authorization of HKIDR and the OTCR':'有關「香港投資者識別碼制度及場外證券交易匯報制度」授權'}}
          </div>
          <div v-else :style="islang=='eng'?'font-size: 18px;width:100%':'font-size: 18px;width:100%'">
            {{islang=='eng'?'Authorization of HKIDR and the OTCR':'有關「香港投資者識別碼制度及場外證券交易匯報制度」授權'}}
          </div>
          <div style="width: 1rem;height: 20px;"></div>
          <div style="height:1px;background-color:#0C8B97"></div>
        </div>
      </div>
      <div style="font-size: 16px; color: #000;" class='fbody' v-if="onlinestate=='pc'">
        <pre class='fonts look_l' >{{islang=='eng'?'Dear Valued Client,':'尊貴的客戶：'}}</pre>
        <pre class='fonts look_l' >{{islang=='eng'?'According to the requirements of the "Personal Information Collection Statement in relation to the Hong Kong Investor Identification Regime (HKIDR) and the Over-The-Counter Securities Transactions Reporting Regime (OTCR)", please read carefully and submit the “Consent to Authorization Instructions”. Failure to provide the above consent may no longer be able to execute orders or transactions of the trading of the Hong Kong Securities in the Stock Exchange Hong Kong (SEHK).':'根據 「香港投資者識別碼制度及場外證券交易匯報制度」之要求，客戶務必詳細閱讀相關協議及條文並提交「同意授權指示」。若客戶未能提交並完成程序，帳戶將不能再執行買入港股的指令或交易。'}}</pre>
        <pre v-if="islang=='eng'" class='fonts look_l' >You can submit the consent or review the submission status by visit<br><a :href="hkidrurl" style="color:#09666E">{{hkidrurl}}.</a></pre>
        <pre v-else class='fonts look_l' >客戶可以通過點擊鏈接前往授權頁面完成授權或查詢是否已完成授權  <a :href="hkidrurl" style="color:#09666E">{{hkidrurl}}</a></pre>
        <pre class='fonts look_l' >{{islang=='eng'?'Please ignore this email if the Client has already done.':'若客戶已進行登記，請不用理會此電郵。'}}</pre>
        <pre  class='fonts look_l' v-if="islang=='eng'">Related Webpages：<br/></pre>
        <pre  class='fonts look_l' v-else>相關網站：<br/></pre>
        <pre v-if="islang=='eng'" class='fonts look_l' >SFC will introduce the HKIDR and the OTCR : <br><a @click="openurl('https://apps.sfc.hk/edistributionWeb/gateway/EN/news-and-announcements/news/doc?refNo=21PR82')" style="color:#09666E">https://apps.sfc.hk/edistributionWeb/gateway/EN/news-and-announcements/news/doc?refNo=21PR82</a></pre>
        <pre v-else class='fonts look_l' >證監會將引入投資者識別碼及場外證券交易滙報制度 <br><a @click="openurl('https://apps.sfc.hk/edistributionWeb/gateway/TC/news-and-announcements/news/doc?refNo=21PR82')" style="color:#09666E">https://apps.sfc.hk/edistributionWeb/gateway/TC/news-and-announcements/news/doc?refNo=21PR82</a></pre>
        <pre v-if="islang=='eng'" class='fonts look_l' >Introduction to the HKIDR for Investors (Leaflet) : <a @click="openurl('https://www.sfc.hk/-/media/EN/files/COM/PDF/HKID_regime_leaflet_Eng_Aug_2021.pdf')" style="color:#09666E">https://www.sfc.hk/-/media/EN/files/COM/PDF/HKID_regime_leaflet_Eng_Aug_2021.pdf</a></pre>
        <pre v-else class='fonts look_l' >給予投資者的香港投資者識別碼制度簡介（單張）<br><a @click="openurl('https://www.sfc.hk/-/media/TC/files/COM/PDF/HKID_regime_leaflet_Chi_Aug_2021.pdf')" style="color:#09666E">https://www.sfc.hk/-/media/TC/files/COM/PDF/HKID_regime_leaflet_Chi_Aug_2021.pdf</a></pre>
        <div :style='{fontSize:onlinestate=="pc"?"":"14px"}' class="my_fonts" style="text-align: left;">{{islang=='eng'?'QMIS Financial Group':'華亞金融集團 謹啟'}}</div>
        <div :style='{fontSize:onlinestate=="pc"?"":"14px"}' class="my_fonts" style="text-align: left;">{{islang=='eng'?'September 16, 2022':'2022年9月16日'}}</div>
      </div>
      <div id="phoneSty" style="font-size: 14px; color: #000;" class='fbody' v-else>
      <div style="height: 262px;margin-bottom: 5px;overflow: auto;">
        <pre class='fonts look_l' >{{islang=='eng'?'Dear Valued Client,':'尊貴的客戶：'}}</pre>
        <pre class='fonts look_l' >{{islang=='eng'?'According to the requirements of the "Personal Information Collection Statement in relation to the Hong Kong Investor Identification Regime (HKIDR) and the Over-The-Counter Securities Transactions Reporting Regime (OTCR)", please read carefully and submit the “Consent to Authorization Instructions”. Failure to provide the above consent may no longer be able to execute orders or transactions of the trading of the Hong Kong Securities in the Stock Exchange Hong Kong (SEHK).':'根據 「香港投資者識別碼制度及場外證券交易匯報制度」之要求，客戶務必詳細閱讀相關協議及條文並提交「同意授權指示」。若客戶未能提交並完成程序，帳戶將不能再執行買入港股的指令或交易。'}}</pre>
        <pre v-if="islang=='eng'" class='fonts look_l' >You can submit the consent or review the submission status by visit<br><a :href="hkidrurl" style="color:#09666E">{{hkidrurl}}.</a></pre>
        <pre v-else class='fonts look_l' >客戶可以通過點擊鏈接前往授權頁面完成授權或查詢是否已完成授權  <a :href="hkidrurl" style="color:#09666E">{{hkidrurl}}</a></pre>
        <pre class='fonts look_l' >{{islang=='eng'?'Please ignore this email if the Client has already done.':'若客戶已進行登記，請不用理會此電郵。'}}</pre>
        <pre  class='fonts look_l' v-if="islang=='eng'">Related Webpages：<br/></pre>
        <pre  class='fonts look_l' v-else>相關網站：<br/></pre>
        <pre v-if="islang=='eng'" class='fonts look_l' >SFC will introduce the HKIDR and the OTCR : <br><a @click="openurl('https://apps.sfc.hk/edistributionWeb/gateway/EN/news-and-announcements/news/doc?refNo=21PR82')" style="color:#09666E">https://apps.sfc.hk/edistributionWeb/gateway/EN/news-and-announcements/news/doc?refNo=21PR82</a></pre>
        <pre v-else class='fonts look_l' >證監會將引入投資者識別碼及場外證券交易滙報制度 <br><a @click="openurl('https://apps.sfc.hk/edistributionWeb/gateway/TC/news-and-announcements/news/doc?refNo=21PR82')" style="color:#09666E">https://apps.sfc.hk/edistributionWeb/gateway/TC/news-and-announcements/news/doc?refNo=21PR82</a></pre>
        <pre v-if="islang=='eng'" class='fonts look_l' >Introduction to the HKIDR for Investors (Leaflet) : <a @click="openurl('https://www.sfc.hk/-/media/EN/files/COM/PDF/HKID_regime_leaflet_Eng_Aug_2021.pdf')" style="color:#09666E">https://www.sfc.hk/-/media/EN/files/COM/PDF/HKID_regime_leaflet_Eng_Aug_2021.pdf</a></pre>
        <pre v-else class='fonts look_l' >給予投資者的香港投資者識別碼制度簡介（單張）<br><a @click="openurl('https://www.sfc.hk/-/media/TC/files/COM/PDF/HKID_regime_leaflet_Chi_Aug_2021.pdf')" style="color:#09666E">https://www.sfc.hk/-/media/TC/files/COM/PDF/HKID_regime_leaflet_Chi_Aug_2021.pdf</a></pre>
      </div>
        <div :style='{fontSize:onlinestate=="pc"?"":"15px"}' class="my_fonts" style="text-align: left;">{{islang=='eng'?'QMIS Financial Group':'華亞金融集團 謹啟'}}</div>
        <div :style='{fontSize:onlinestate=="pc"?"":"15px"}' class="my_fonts" style="text-align: left;">{{islang=='eng'?'September 16, 2022':'2022年9月16日'}}</div>
      </div>
    </a-modal>
  </div>
</template>

<script>
  export default {
    props: ['items'],
    data() {
      return {
        hkidrurl:location.protocol+"//"+location.host+(location.host=='120.79.92.205'?'/qmisgroup/HKIDR':'/HKIDR'),
        // onlinestate:'ios',
        onlinestate:sessionStorage['onlinestate'],
        islang: window.localStorage.guanwanglang,
        visible: true,
        params: {
          disclaimer_title: '免責聲明',
        }
      }
    },
    mounted() {
      this.getdate()
    },
    methods: {
      handisok() {
        this.visible = false
      },
      openurl(url){
        window.open(url)
      },
      getdate() {
        // this.$ajax({
        //   method: 'post',
        //   url: this.$api.getGroupRevelation,
        //   data: {
        //     "lan": window.localStorage.guanwanglang,
        //     // "noticeid": this.items.noticeid
        //   }
        // }).then(res => {
        //   if (res.data.qmiscode === 1000) {
        //     this.params = res.data
        //     if (window.sessionStorage['isagree'] == 1) {
        //       this.visible = true
        //     }else{
        //        this.visible = true
        //     }
        //   }
        // })
      },
      handleCancel() {
        window.sessionStorage['isagree_second'] =1
        this.visible= false;
      },
      handleOk() {
        // console.log(111112)
      },
    }
  }
</script>

<style>
#handitem_nz *{
  font-family: "Roboto","Microsoft JhengHei","sans-serif" !important;;
}
  #mybtn_sc {
    cursor: pointer;
    color: #fff;
    font-size: 16px;
    background-color: #eaeaea;
    border: 0;
    width: 5rem;
    height: 2rem;
    outline: none;
    padding: .3rem .6rem;
    border-radius: 6px;
    /* margin: 0 2rem; */
  }

  #mybtn_iconc {
    cursor: pointer;
    /* margin: 0 2rem; */
    border-radius: 6px;
    height: 2rem;
    width: 5rem;
    color: #fff;
    font-size: 16px;
    background-color: #0C8B97;
    border: 0;
    outline: none;
    padding: .3rem .6rem;
  }

  #mybtn_sc:hover {
    color: #09666E;
    border: 1px solid #09666E;
    background-color: #fff;
  }

  #handitem_nz .ant-modal-close-x {
    font-size: 18px;
    top: 18px;
    right:4px;
    position: relative; 
  }
  .appclass .ant-modal-close-x {
    top: 0px !important;
    right:0px !important;
    width: 40px;
    line-height: 35px;
  }
  .appclass .ant-modal-body{
    padding-bottom: 10px !important;
  }

#handitem_nz .ant-modal{
border-top: #09666E;
border-top-width: 8px;
border-top-style: solid;
border-bottom: #09666E;
border-bottom-width: 8px;
border-bottom-style: solid;
padding-bottom: 0 !important;
}

  #handitem_nz .ant-modal-content {
    border-radius: 0 !important;
  }

  #handitem_nz .ant-modal-content svg:hover {
    color: #09666E !important;
  }

  #handitem_nz .myleft{
    text-align: right;padding-right: 4.7rem;
  }
   #handitem_nz .myleft_en{
     text-align: right;
  }
  #handitem_nz .look_l{
    font-size: 16px;
    margin-bottom: 0.8rem;
  }
  #phoneSty .look_l{
    font-size: 15px;
    margin-bottom: 0.5rem;
  }
  #handitem_nz .look_w {
    font-weight: 600;
  }
  #handitem_nz .fbody{
    padding-top:33px !important;
  }
  #handitem_nz #phoneSty{
    padding-top:1.3rem !important;
  }
  .fbody{
    padding: 0 !important;
  }
  .my_fonts{
    color: #333;
  }

</style>



// WEBPACK FOOTER //
// src/components/login/handitems2.vue